import React from 'react';
import SearchMap from './SearchMap';
import SearchList from './SearchList';
import styled from "styled-components";
import EnableFilterAtSidebar from "./components/EnableFilterAtSidebar";
import SearchForm from "./SearchForm";

const WorkplaceSearch = (props) => {
    const [currentViewIsMap, setCurrentViewIsMap] = React.useState(true);
    const [isSearchFormVisible, setIsSearchFormVisible] = React.useState(true);
    const urlParams = new URLSearchParams(window.location.search);
    const [defaultFilterParams, setDefaultFilterParams] = React.useState({
        term_age: Boolean(urlParams.get('age')) ? [urlParams.get('age')] : [],
        term_service: Boolean(urlParams.get('service')) ? [urlParams.get('service')] : [],
        term_institution_id: Boolean(urlParams.get('institution_id')) ? [parseInt(urlParams.get('institution_id'))] : [],
        term_work_category_id: Boolean(urlParams.get('work_category_id')) ? [parseInt(urlParams.get('work_category_id'))] : [],
        radius: 50000,
    });
    const [filterParams, setFilterParams] = React.useState(defaultFilterParams);

    React.useEffect(() => {
        // we want to keep the filter params when search is hidden, so current filterParams get the new default.
        if (isSearchFormVisible === false) {
            setDefaultFilterParams(filterParams);
        }
    }, [isSearchFormVisible]);

    return (
        <WorkplaceSearchBox>
            {isSearchFormVisible && <SearchForm settings={props.settings}
                                                defaultFilterParams={defaultFilterParams}
                                                filterParams={filterParams}
                                                setFilterParams={setFilterParams}
                                                currentViewIsMap={currentViewIsMap}
                                                setCurrentViewIsMap={setCurrentViewIsMap}
                                                setIsSearchFormVisible={setIsSearchFormVisible}
            />}
            {!isSearchFormVisible && <EnableFilterAtSidebar
                setIsSearchFormVisible={setIsSearchFormVisible}
            />}
            {currentViewIsMap
                ? <SearchMap settings={props.settings}
                             defaultFilterParams={defaultFilterParams}
                             filterParams={filterParams}
                             setFilterParams={setFilterParams}
                             setCurrentViewIsMap={setCurrentViewIsMap}
                             currentViewIsMap={currentViewIsMap}
                             setIsSearchFormVisible={setIsSearchFormVisible}
                             isSearchFormVisible={isSearchFormVisible} />
                : <SearchList settings={props.settings}
                              defaultFilterParams={defaultFilterParams}
                              filterParams={filterParams}
                              setCurrentViewIsMap={setCurrentViewIsMap}
                              currentViewIsMap={currentViewIsMap}
                              setIsSearchFormVisible={setIsSearchFormVisible}
                              isSearchFormVisible={isSearchFormVisible} />}
        </WorkplaceSearchBox>
    );
};


const WorkplaceSearchBox = styled.div`
    position: relative;
`;

export default WorkplaceSearch;
